import {mixins} from "../app/mixin";

mixins.push({
    el: '.cdpPage',
    data() {
        return {
            selectedStep: 1,
            selectedBenefit: 1
        }
    },
    methods: {
        selectStep(index) {
            if (index !== this.selectedStep) {
                this.selectedStep = index;
            }
        },
        selectBenefit(index) {
            if (index !== this.selectedBenefit) {
                this.selectedBenefit = index;
            }
        }
    },
});